import React from 'react';
import styles from 'src/components/star-grid/components/styles/ReportStudio.module.scss';

export const StudioFilterPill: React.FC<React.HTMLAttributes<HTMLElement>> = ({ children, className, ...props }) => (
  <article {...props} className={[styles.filterPill, className].filter(Boolean).join(' ')}>
    {children}
  </article>
);
